import { createAction } from '@reduxjs/toolkit';
import { SECOND_IN_MS, EXPERT_MESSAGES } from '@packages/shared/core/common/constants';
import { AppThunk } from '@packages/shared/core/common/store';
import { delay } from '@packages/shared/core/common/utils/delay';
import { randomNumber } from '@packages/shared/core/common/utils/random';
import { ExpertId } from '@packages/shared/core/experts/entities';
import { getChatCount, getIncomingMessage } from './selectors';

export const messageSent = createAction<{ expertId: ExpertId; text: string }>('chat/MESSAGE_SENT');

export const messageReceived = createAction<{
  expertId: ExpertId;
  text: string;
}>('chat/MESSAGE_RECEIVED');
export const chatCountIncreased = createAction(`chat/CHAT_COUNT_INCREASED`);

export const chatSessionUpdated = createAction<ExpertId>('chat/SESSION_UPDATED');

export const messageReceivedRequest =
  (expertId: ExpertId): AppThunk =>
  async (dispatch, getState) => {
    const incomingMessage = getIncomingMessage(expertId)(getState());
    const chatCount = getChatCount(getState());

    if (!incomingMessage) {
      await delay(3 * SECOND_IN_MS);

      const randomIndex = randomNumber(0, EXPERT_MESSAGES.length - 1);
      const textMessage = EXPERT_MESSAGES[chatCount] ?? EXPERT_MESSAGES[randomIndex];

      dispatch(messageReceived({ expertId, text: textMessage }));
      dispatch(chatCountIncreased());
    }
  };
